import { render, staticRenderFns } from "./loadometer.vue?vue&type=template&id=02facb22&scoped=true"
import script from "./loadometer.vue?vue&type=script&lang=js"
export * from "./loadometer.vue?vue&type=script&lang=js"
import style0 from "./loadometer.vue?vue&type=style&index=0&id=02facb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02facb22",
  null
  
)

export default component.exports